import Styles from "./DataView.module.css";

const DataView = ({ fields = [] }) => {
  if (!fields.length) return null;

  return (
    <div className="container-fluid p-0 my-4">
      <div className={`p-4 ${Styles.card}`}>
        <div className="row my-2">
          {fields.map(({ label, value, columnSize }, index) => (
            <div className={`${columnSize || "col-md-4"} mb-3`} key={index}>
              <div className={`${Styles.label}`}>{label}</div>
              <div className={Styles.value}>{value ?? " "}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DataView;
